import { render } from "./KycUpload.vue?vue&type=template&id=ace06e22&scoped=true"
import script from "./KycUpload.vue?vue&type=script&lang=js"
export * from "./KycUpload.vue?vue&type=script&lang=js"

import "./KycUpload.vue?vue&type=style&index=0&id=ace06e22&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace06e22"]])

export default __exports__